import React from 'react';
import './styles.css';
import useRoomState, { RoomState } from '../../hooks/useRoomState';
import { ReconnectionBlue } from '../../utils/colors';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../components/VideoRoomI18n';
import InfoIcon from '../../icons/InfoIcon';
export default function ReconnectingNotification() {
  var roomState = useRoomState();

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  return /*#__PURE__*/React.createElement(React.Fragment, null, roomState === RoomState.reconnecting && /*#__PURE__*/React.createElement("div", {
    className: "snackbar__container",
    style: {
      backgroundColor: ReconnectionBlue
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "notification__message"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: "notification__icon"
  }), format(VideoRoomI18nMessage.reconnecting), "\u2026")));
}